import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import RootContainer from './components/RootContainer/RootContainer';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Router>
          <Route path="/order/:id" component={RootContainer} />
        </Router>
      </div>
    );
  }
}

export default App;
